import { h } from 'preact';
import { accessNested } from 'utils/utils';
import ScreeningsByCategory from 'components/shared/theaters/screeningsByCategory';
import s from 'components/shared/theaters/screenings.sss';


export default class ScreeningsByTitle extends ScreeningsByCategory {

	getLookup(screenings) {
		const perTitle = {};

		screenings.forEach(screening => {
			const title = screening.movie.title;

			if (!perTitle[title]) {
				perTitle[title] = [];
			}
			perTitle[title].push(screening);
		});

		return Object.keys(perTitle).map(key => ({ name: key, screenings: perTitle[key] }));
	}

	getCategoryName(category) {
		const {
			pageData = {},
			appData = {},
			stDate = {},
			theater = {}
		} = this.props;
		const separator = pageData.nameSeparator || ': ';
		const copy = appData.copy || {};
		const hideMovieName = accessNested(appData, 'options.hideMovieName');
		const overrides = pageData.titleOverrides || {};
		let name = category.name;
		const matchingOverride = Object.keys(overrides).map(key => overrides[key]).find(context => {
			if (!context || typeof context !== 'object') {
				return false;
			}
			if (context.date) {
				let list = context.date.split(',').map(e => e.trim()).filter(e => e);
				if (list.indexOf(stDate.yyyymmdd) === -1) {
					return false;
				}
			}
			if (context.theater) {
				let list = context.theater.split(',').map(e => e.trim()).filter(e => e);
				if (list.indexOf(theater.pid) === -1 && list.indexOf(theater.id) === -1) {
					return false;
				}
			}
			if (context.sourceTitle && name !== context.sourceTitle) {
				return false;
			}
			return true;
		});
		if (matchingOverride) {
			name = matchingOverride.title || '';
		}
		const title = copy.$TITLE_OVERRIDE || copy.$TITLE;
		const fullTitle = [
			!hideMovieName && title,
			name
		].filter(e => e).join(separator);
		return <div class={s.screeningMovie}>{category.screenings.length > 0 ? fullTitle : ''}</div>;
	}

}
